const inventory_settings = {
  permissionSource: 'api::inventory-setting.inventory-setting',
  detailTitle: 'Inventory Setting',
  detailEndPoint: '/inventory-setting',
  detail: [
    {
      label: 'Low/Empty Stock Alarm Email Addresses',
      value: 'alarm_target_emails',
      tag: 'input',
      type: 'text',
      validateGroup: ['multiple-emails'],
      placeholder: 'Type multiple email and separate with comma',
    },
  ],
}
export default inventory_settings
